export const menuList = [
    {
      id: 1,
      path: '/',
      name: 'Home',
      icon: '',
      desc: '',
      submenu: []
    },
    {
      id: 2,
      path: '/about',
      name: 'About',
      icon: '',
      desc: '',
      submenu: []
    },
    {
      id: 3,
      path: '/services',
      name: 'Services',
      icon: '',
      desc: '',
      submenu: [
        // {
        //   id: 1,
        //   path: '#',
        //   name: 'labour Outsourcing',
        //   icon: '',
        //   desc: ''
        // },
        // {
        //   id: 2,
        //   path: '/service-consulting',
        //   name: 'HR Consulting',
        //   icon: '',
        //   desc: ''
        // },
        // {
        //   id: 3,
        //   path: '#recruitment-labour',
        //   name: 'Recruitment and placement',
        //   icon: '',
        //   desc: ''
        // },
        // {
        //   id: 4,
        //   path: '/service-consulting',
        //   name: 'Expert HR advisory & solutions',
        //   icon: '',
        //   desc: ''
        // },
        // Add more submenu items as needed
      ]
    },
    {
      id: 4,
      path: '/project',
      name: 'Projects',
      icon: '',
      desc: '',
      submenu: [
        // {
        //   id: 1,
        //   path: '/project',
        //   name: 'Projects',
        //   icon: '',
        //   desc: ''
        // },
        // {
        //   id: 2,
        //   path: '/project-details',
        //   name: 'Projects Details',
        //   icon: '',
        //   desc: ''
        // },
        // Add more submenu items as needed
      ]
    },
    {
        id: 5,
        path: '/history',
        name: 'History',
        icon: '',
        desc: '',
        submenu: []
      },
    {
      id: 6,
      path: '/news',
      name: 'News',
      icon: '',
      desc: '',
      submenu: [
        // {
        //   id: 1,
        //   path: '/news',
        //   name: 'News',
        //   icon: '',
        //   desc: ''
        // },
        // {
        //   id: 2,
        //   path: '/blog-details',
        //   name: 'News Details',
        //   icon: '',
        //   desc: ''
        // },
        // Add more submenu items as needed
      ]
    },
    {
      id: 7,
      path: '/contact',
      name: 'Contact',
      icon: '',
      desc: '',
      submenu: []
    }
  ];
  